/**
 * Demo mode is a SystemAdmin-only, read-only presentation mode. The flag lives in
 * localStorage so it survives the full-page reload used to enter/exit demo mode, and is
 * read by the transport layer (apiFetch) which attaches the demo header to every request.
 * The backend only honors the header for SystemAdmins, so a non-admin toggling this does
 * nothing.
 */
const DEMO_MODE_KEY = "tower.demo";

/** Header the backend inspects to decide whether to serve synthetic demo data. */
export const DEMO_MODE_HEADER = "X-Demo-Mode";

export function isDemoMode(): boolean {
  if (globalThis.localStorage === undefined) {
    return false;
  }

  try {
    return globalThis.localStorage.getItem(DEMO_MODE_KEY) === "1";
  } catch {
    return false;
  }
}

export function setDemoMode(enabled: boolean): void {
  if (globalThis.localStorage === undefined) {
    return;
  }

  try {
    if (enabled) {
      globalThis.localStorage.setItem(DEMO_MODE_KEY, "1");
    } else {
      globalThis.localStorage.removeItem(DEMO_MODE_KEY);
    }
  } catch {
    // Storage may be unavailable (private mode / quota). Demo mode is best-effort.
  }
}
